import React, { Component, useState } from "react";
import { StyleSheet, View, TextInput, Text } from "react-native";
import Joi from "react-native-joi";

function InputLayout(props) {
  const [isFailed, setFailed] = useState(false);
  const schema = props.schema;
  const errorMessage = props.errorMessage;
  const testFailed = (text) => {
    if (schema) {
      setFailed(Joi.validate(text, schema).error);
      if (props.isValid) props.isValid();
    }
  };
  return (
    <View style={{ ...styles.container, ...props.style }}>
      <TextInput
        style={styles.label}
        placeholder={props.placeholder}
        secureTextEntry={props.secureTextEntry}
        onChangeText={(text) => {
          props.onChangeText(text);
          testFailed(text);
        }}
        value={props.value}
        keyboardType={
          props.keyboardType !== null ? props.keyboardType : "default"
        }
        autoCompleteType={
          props.autoCompleteType !== null ? props.autoCompleteType : "off"
        }></TextInput>
      {isFailed && (
        <Text
          style={{
            marginLeft: 15,
            marginTop: 5,
            fontFamily: "Nunito-Regular",
            color: "red",
          }}>
          {errorMessage ? errorMessage : "Failed"}
        </Text>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: "Montserrat-Bold",
    color: "#3E4672",
    fontSize: 17,
    marginTop: 4,
    textAlign: "center",
    width: 150,
  },
  container: {
    borderStyle: "solid",
    borderWidth: 0.3,
    borderColor: "#ACACAC",
    height: 38,
    alignSelf: "center",
    backgroundColor: "#fff",
    borderRadius: 15,
    marginBottom: 20,
    marginTop: 20,
    overflow: "scroll",
  },
});

export default InputLayout;
